
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import DocsLayout from '../../components/DocsLayout'
import NextPage from '../../components/NextPage'
import Theming from '../../sections/advanced/theming.md'
import Refs from '../../sections/advanced/refs.md'
import Security from '../../sections/advanced/security.md'
import ExistingCSS from '../../sections/advanced/existing-css.md'
import TaggedTemplateLiterals from '../../sections/advanced/tagged-template-literals.md'
import ServerSideRendering from '../../sections/advanced/server-side-rendering.md'
import ComponentsAsSelectors from '../../sections/advanced/components-as-selectors.md'
import StyleObjects from '../../sections/advanced/style-objects.md'


const layoutProps = {
  
};
const MDXLayout = function({ children }) {
  return (
    <DocsLayout
      title="Advanced Usage"
      description="Theming, refs, Security, Existing CSS, Tagged Template Literals, Server-Side Rendering and Style Objects"
    >
      {children}
    </DocsLayout>
  )
}
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Theming mdxType="Theming" />
    <Refs mdxType="Refs" />
    <Security mdxType="Security" />
    <ExistingCSS mdxType="ExistingCSS" />
    <TaggedTemplateLiterals mdxType="TaggedTemplateLiterals" />
    <ServerSideRendering mdxType="ServerSideRendering" />
    <ComponentsAsSelectors mdxType="ComponentsAsSelectors" />
    <StyleObjects mdxType="StyleObjects" />
    <NextPage href="/docs/api" title="API Reference" mdxType="NextPage" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;